"use client"

import { FormEvent } from 'react';
import Input from '@aura-design/system/input';
import { useForm } from '@aura-design/system/form';
import { useRouter } from 'next/navigation';

type SearchInputProps = {
  onClose?: () => void;
};

const SearchInput = ({ onClose }: SearchInputProps) => {
  const router = useRouter();

  const formData = useForm({
    s: '',
  });

  const { s } = formData;

  const handleOnSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (s.value) {
      router.push(`/buscar/${s.value}`);
      if (onClose) onClose();
    }
  };

  return (
    <div className="text-left">
      <form onSubmit={handleOnSubmit}>
        <label>Buscar</label>
        <Input {...s} />
      </form>
    </div>
  );
};

export default SearchInput;
